import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import { useEffect } from 'react';
import { useFormWizardaUpdate, useFormWizardState } from '../../context/formWizardProvider';
const WizardItem = (({ StepName, children, GoBack, PositionPercent, fitHeight = false, className, inModal }) => {
    const { currentStepName, wrapperWidth, moving } = useFormWizardState();
    const { setGoBack, setPositionPercent } = useFormWizardaUpdate();
    const styleConfigs = fitHeight ? { width: `${wrapperWidth}px`, height: '100%' } : { width: `${wrapperWidth}px`, minHeight: inModal ? 'inherit' : '534px', height: '100%' };
    useEffect(() => {
        if (currentStepName === StepName) {
            setGoBack(GoBack);
            PositionPercent && setPositionPercent(PositionPercent);
        }
    }, [currentStepName, StepName]);
    return currentStepName === StepName ?
        _jsx(motion.div, { whileInView: "done", variants: variants, initial: "enter", animate: "center", exit: "exit", custom: { direction: moving === "back" ? -1 : 1, width: wrapperWidth }, children: _jsx("div", { style: styleConfigs, className: className, children: Number(wrapperWidth) > 1 && children }) }, currentStepName)
        : null;
});
let variants = {
    enter: ({ direction, width }) => ({
        x: direction * width,
    }),
    center: {
        x: 0,
        transition: {
            duration: 0.2,
            when: "beforeChildren",
        },
    },
    exit: ({ direction, width }) => ({
        x: direction * -width,
    }),
};
export default WizardItem;
